import Vue from 'vue';
import mixin from './../../../mixins/mixin';

export default {
  data() {
    return {
        user: {
            full_name: null,
            email: null,
            phone: null,
            description: null,
            password: null,
            active: 1,
            role_id: 2,
            avatar: "",
        },
        change_password: false,
        error: null,
        success: false,
        loading: false
    };
  },
  components: {
    VLayout: require('layouts/default/default.vue'),
    VPanel: require('components/panel/panel.vue'),
    VLoading : require('components/loading/loading.vue')
  },
    mixins:[mixin],
  mounted() {
    this.getChannels();
    if(this.$route.params.id){
      this.fetch_user(this.$route.params.id);
    }else{
      this.loading = false;
    }
    if (typeof (window.Site) !== 'undefined') {
      window.Site.getInstance().initializePlugins();
    }
  },
  methods: {
    getChannels() {
        //TODO Use Service for getting Channels
        Vue.$http.get('/channels')
            .then((response) => {
                this.channels = response.data.channels;
            })
            .catch((error) => {
                console.log(error);
            });
    },
    delete_user (id) {
          var vm = this;
          swal({
                  title: "Are you sure?",
                  text: '<div style="display: none; height: 100px" id="loading1" class="loader-wrapper"><div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="4"/></svg></div></div><div>You will not be able to recover this user</div>',
                  type: "warning",
                  showCancelButton: true,
                  confirmButtonClass: "btn-warning",
                  confirmButtonText: 'Yes, delete it!',
                  closeOnConfirm: false,
                  html: true
              },
              function() {
                  $(".cancel").addClass("disabled");
                  $(".confirm").addClass("disabled");
                  $(".pulseWarning").hide();
                  $("#loading1").show();
                  Vue.$http.delete('/sub-users/'+id).then((response) => {
                      //TODO Use Service for deleting sub user
                      if (response && response.status === 200) {
                          $(".cancel").removeClass("disabled");
                          $(".confirm").removeClass("disabled");
                          swal("Deleted!", "Your imaginary user has been deleted!", "success");
                          vm.loading = false;
                          Vue.router.push({
                              name: 'users.index',
                          });
                      }
                  }).catch((error) => {
                      if (error.response) {
                          $(".cancel").removeClass("disabled");
                          $(".confirm").removeClass("disabled");
                          swal("Error!", error.response.data.msg, "warning");
                          //this.error = error.response.data.msg;
                          toastr.error(error.response.data.msg);
                          vm.loading = false;
                      }
                  });

              });
      },
    save_user(userData) {
      var vm = this;

      var img = vm.avatar;

      let formData = new FormData();
      formData.append('image', img);
      formData.append('folder', 'users');
      if(img && img.name) {
          vm.loading = true;
          //TODO Use Service for files request
          Vue.$http.post('/files', formData).then((response) => {
              if (response && response.status === 200) {
                  userData.avatar = response.data.image;
                      //TODO Use Service for create sub users
                      Vue.$http.post('/sub-users', userData).then((response) => {
                          if (response && response.status === 200) {
                              Vue.router.push({
                                  name: 'users.index',
                              });
                              vm.loading = false;
                          }
                      }).catch((error) => {
                          if (error.response) {
                              vm.loading = false;
                              //vm.error = error.response.data.msg;
                              //vm.success = false;
                              vm.showToasterError(error);
                          }
                      });
              }
          }).catch((error) => {
              if (error.response && error.response.data && error.response.data.msg) {
                  vm.loading = false;
                  //vm.error = error.response.data.msg.image[0];
                  toastr.error(error.response.data.msg.image[0]);
              } else {
                  //vm.error = error.response.message;
                  toastr.error(error.response.data.msg);
              }
          });
      }else{
          vm.loading = false;
          //vm.error = "Avatar is required!";
          toastr.error("Avatar is required!");
      }
    },
    edit_user (user){
        if(this.change_password){
            user.change_password = 1;
        }else{
            user.change_password = 0;
        }
        var vm = this;
        //vm.error = vm.success = false;
        var img = vm.avatar;
        var image = {"image": img};

        let formData = new FormData();
        formData.append('image', img);
        formData.append('folder', 'users');

        if(img && img.name) {
            //TODO Use Service for files request
            Vue.$http.post('/files', formData).then((response) => {
                if (response && response.status === 200) {
                    user.avatar = response.data.image;
                    vm.update_user(user);
                }
            }).catch((error) => {
                console.log(error);
                if (error.response && error.response.data && error.response.data.msg) {
                    //vm.error = error.response.data.msg.image[0];
                    toastr.error(error.response.data.msg.image[0]);
                } else {
                    //vm.error = error.response.message;
                    toastr.error(error.response.data.msg);
                }
            });
        }else{
            vm.update_user(user);
        }
    },
    onAvatarChange(e) {
        var files = e.target.files || e.dataTransfer.files;
        if (!files.length){
            return;
        }
        this.avatar = files[0];
    },
    fetch_user(id){
        //TODO Use Service for fetching user
        Vue.$http.get('/users/'+id).then((response) => {
            if (response && response.status === 200) {
                this.user = response.data.user;
                this.loading = false;
            }
        });
    },
    update_user(user){
        var vm = this;
        vm.loading = true;
        //TODO Use Service for updating sub user
        Vue.$http.put('/sub-users/'+user.id, user).then((response) => {
            if (response && response.status === 200) {
                //vm.success = response.data.msg;
                toastr.success(response.data.msg);
                vm.loading = false;
                Vue.router.push({
                    name: 'users.index',
                });
            }
        }).catch((error) => {
            if (error.response) {
                vm.showToasterError(error);
            }
        });
      },
  }
};



// WEBPACK FOOTER //
// ./src/app/pages/users/detail/detail.js